module.exports = __webpack_public_path__ + "img/menuicon.cd5433ff.svg";